module.exports = __webpack_public_path__ + "img/saba_achal_yes.98ad3ffe.png";